var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('top-header'),_c('content-data',{staticClass:"content"}),_c('footer-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }